<script lang="ts">
  import { api, ApiError } from '$shared/api';

  let status = $state<'loading' | 'success' | 'error'>('loading');
  let errorMessage = $state('');

  $effect(() => {
    const hash = window.location.hash;
    const queryString = hash.includes('?') ? hash.split('?')[1] : '';
    const params = new URLSearchParams(queryString);
    const token = params.get('token');

    if (!token) {
      status = 'error';
      errorMessage = 'Missing verification token.';
      return;
    }

    api
      .get<{ message?: string }>(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => {
        status = 'success';
      })
      .catch((err) => {
        console.error('Email verification failed:', err);
        status = 'error';
        if (
          err instanceof ApiError &&
          err.data &&
          typeof err.data === 'object' &&
          'message' in (err.data as Record<string, unknown>)
        ) {
          errorMessage = (err.data as Record<string, string>).message;
        } else if (err instanceof ApiError) {
          errorMessage = err.message;
        } else {
          errorMessage = 'Something went wrong. Please try again.';
        }
      });
  });
</script>

<div class="verify-wrapper">
  <div class="verify-card">
    <h2>Email Verification</h2>
    {#if status === 'loading'}
      <p class="status-msg">Verifying your email...</p>
      <div class="spinner-wrapper">
        <span class="spinner"></span>
      </div>
    {:else if status === 'success'}
      <p class="success-msg">Your email has been verified successfully!</p>
      <a href="#/login" class="btn btn-primary full-width">Go to Login</a>
    {:else}
      <p class="msg--error">{errorMessage}</p>
      <a href="#/login" class="btn btn-primary full-width">Back to Login</a>
    {/if}
  </div>
</div>

<style>
  .verify-wrapper {
    display: flex;
    justify-content: center;
    padding-top: 2rem;
  }
  .verify-card {
    max-width: 400px;
    width: 100%;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 2.5rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
    align-items: center;
  }
  .verify-card h2 {
    text-align: center;
    color: var(--text);
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0 0 0.5rem;
    -webkit-text-fill-color: var(--text);
    background: none;
    background-clip: unset;
    -webkit-background-clip: unset;
  }
  .status-msg {
    color: var(--text-muted);
    text-align: center;
    font-size: 0.9375rem;
  }
  .success-msg {
    color: var(--cyan);
    text-align: center;
    font-size: 0.9375rem;
  }
  .full-width {
    width: 100%;
    padding: 0.625rem;
    text-align: center;
  }
  .spinner-wrapper {
    display: flex;
    justify-content: center;
    padding: 0.5rem 0;
  }
  .spinner {
    width: 28px;
    height: 28px;
    border: 3px solid var(--border);
    border-top-color: var(--accent);
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
